export interface ElementPosition {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function position(element: HTMLElement): ElementPosition {
  let box: DOMRect;

  try {
    box = element.getBoundingClientRect();
  } catch (e) {}

  let doc = document,
    docElem = doc.documentElement,
    body = document.body,
    win = window,
    clientTop = docElem.clientTop || body.clientTop || 0,
    clientLeft = docElem.clientLeft || body.clientLeft || 0,
    scrollTop = win.pageYOffset || body.scrollTop,
    scrollLeft = win.pageXOffset || body.scrollLeft,
    top = box.top + scrollTop - clientTop,
    left = box.left + scrollLeft - clientLeft;

  return {
    x: left,
    y: top,
    width: box.width,
    height: box.height,
  };
}
